// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3GBr-","footer":"ModalError_footer__2Becn"};